import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';

const HubAvatar = ({ src, size, ...rest }) => {
  size = size || 40;
  const iconStyle = { fontSize: size + 'px', width: size + 'px', height: size + 'px', };
  const accountIcon = <FontIcon style={iconStyle} className="material-icons">account_circle</FontIcon>;
  return src ? (
    <Avatar src={src} {...{size}} {...rest}/>
  ) : (
    <Avatar src={src} icon={accountIcon} color="white" {...{size}} {...rest}/>
  )
}

HubAvatar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
}

export default HubAvatar;



// WEBPACK FOOTER //
// ./src/components/HubAvatar/index.jsx